<app-header></app-header>


<div class="container container-form margin-top-1">

  <!-- Image -->
  <div class="flex-center">
    <img class="width-80" src="assets/img/logo.svg" />
  </div>

  <!-- Form -->
  <form [formGroup]="form">

    <!-- Password -->
    <mat-form-field appearance="legacy" class="margin-top-1">
      <mat-label>{{'password'|translate}}</mat-label>
      <input matInput formControlName="password" type="password">
      <mat-error *ngIf="invalidPassword"> {{'valid-password'|translate}}
      </mat-error>
    </mat-form-field>

    <!-- Repeat Password -->
    <mat-form-field appearance="legacy" class="margin-top-1">
      <mat-label>{{'repeat-password'|translate}}</mat-label>
      <input matInput formControlName="repeatPassword" type="password">
      <mat-error *ngIf="!validRepeatPassword"> {{'valid-repeat-password'|translate}}
      </mat-error>
    </mat-form-field>

    <div class="row justify-content-center">
      <!-- Send Form -->
      <button mat-raised-button color="primary" class="width-50 margin-top-1 margin-bottom-05 text-uppercase" [class.spinner]="loading"
        (click)="changePassword()" [disabled]="form.invalid">
        <span>{{'send'|translate}}</span>
      </button>
    </div>
  </form>
</div>